<template>
    <div>
      <van-nav-bar
        title="屏蔽公司"
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft">
      </van-nav-bar>
      <div class="title-sm">已屏蔽公司（共 5 个）</div>
      <ul class="companies">
        <li v-for="item in companies" :key="item.index">
          <div class="name">
            <img :src="item.logo"/>
            <h2>{{item.name}}</h2>
          </div>
          <button>取消屏蔽</button>
        </li>

      </ul>
    </div>
</template>

<script>
export default {
  name: 'shieldCompanies',
  data() {
    return {
      companies: [
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司'
        },
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司'
        },
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司'
        },
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司'
        },
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司'
        },
        {
          logo: require('@/assets/img/logo2.jpg'),
          name: '上海良信电器股份有限公司'
        }
      ]
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .title-sm{
    padding:16px 20px;
    color:#515255;
    border-bottom: 1px solid #eee;
  }
  .companies{
    li{
      display: flex;
      align-items: center;
      margin:0 16px;
      padding:16px 0;
      justify-content: space-between;
      border-bottom:1px solid #eee;
      .name{
        display: flex;
        align-items: center;
        img{
          width: 50px;
          height: 50px;
          border-radius: 10px;
          object-fit: cover;
        }
        h2{
          font-size: 14px;
          color:#3A3A3A;
          margin-left: 10px;
          font-weight: bold;
        }
      }
      button{
        padding:4px 12px;
        background: #E4EBFB;
        color:#4469E3;
        border-radius: 50px;
        border:1px solid #4469E3;
        font-size: 12px;
      }
    }
  }

</style>
